
















































import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class RestaurantPartnersDelete extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('profileValue', {}) profileValueSync!: any;

  @Prop({}) profileLists!: string;

  @Prop({ default: 1 }) selectedCount!: number;

  public close() {
    this.$emit('cancel');
  }

  public onDelete() {
    this.$emit('delete');
  }

  get canDeactivate() {
    return this.profileValueSync.deleteProfile.toLowerCase().trim() === 'delete';
  }
}
